import axios from "../utils/axios";

export const getMyInvoicesApi = () =>
  axios.get("/api/invoice/my-invoices");

export const getCurrentInvoiceApi = () =>
  axios.get("/api/invoice/current-invoice");

export const getSystemSettingApi = () =>
  axios.get("/api/system/setting/setting");

export const submitPaymentApi = (data) =>
  axios.post(
    "/api/restaurant/payment/submit-payment",
    data
  );
export const getSubscriptionDetailsApi = () =>
  axios.get(
    "/api/subscription/subscription-details"
  );